import React, { useEffect, useState } from "react";
import {SUBSCRIPTION_TEXT,SUBSCRIPTION_URL,VIEW_TEXT,NEW_TAB_OPEN,SUBSCRIPTION_RENEWAL_VALUE,SUBSCRIPTION_ERROR_MSG} from "../../../helper/constants";
import "./SubscriptionRenewal.scss";

import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

export const SubscriptionRenewal = () => {
  const { t } = useTranslation();
  const [subscriptionCount,setSubscriptionCount]=useState(0);
 const[showSubscriptionLayout,setShowSubscriptionLayout]=useState(false);
 const[subscriptionData,setSubscriptionData]=useState([]);
 const urlPath = window.location.pathname.includes("/viewcollection");
  const tempRevUrl = window.location.pathname.includes("/temprevisions");
  const relatedpubUrl = window.location.pathname.includes("/relatedpub");
  const { hid } = useSelector((state: any) => state.config);


  const subsCount = async () => {
    try{
    const response =  await fetch("/api/techpub/v1/expiringSubscription", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({

      honId:hid

      }),
    });

    const data =  await response.json();
    setSubscriptionData(data.message.result);
    const subscriptionCountData=[...data.message.result];
    let subscriptionInitialCount=0;
    if(subscriptionCountData!==undefined && subscriptionCountData.length>0){

       subscriptionCountData.map((item)=>{
        
       if(item?.reviewRenewInvoice?.toLowerCase() === SUBSCRIPTION_RENEWAL_VALUE ){
              subscriptionInitialCount=subscriptionInitialCount+1;
              setSubscriptionCount(subscriptionInitialCount);
              setShowSubscriptionLayout(true);
      }
  });}

    }catch(error){
      console.error(SUBSCRIPTION_ERROR_MSG,error);
    }
  };
useEffect(()=>{

  subsCount();

},[]);

const openTab=()=>{
    window.open(SUBSCRIPTION_URL, NEW_TAB_OPEN);
};
  return (
    <>
    {showSubscriptionLayout &&
        (
    <div className={urlPath || tempRevUrl || relatedpubUrl ? "cls-subscriptionView":"cls-subscriptionLayout"}> 

      <div className="cls-subscriptionTextLayout" onClick={openTab}>

       {subscriptionCount}


     </div>
     <div className="cls-subscriptionContent">{SUBSCRIPTION_TEXT}</div>
       <a className="cls-subscriptionViewText" onClick={openTab}>{VIEW_TEXT}</a>
    </div>
        )
    }
    </>
  );
};
export default SubscriptionRenewal;